import {
  CBadge,
  CCol,
  CContainer,
  CForm,
  CRow,
} from "@coreui/react";
import React from "react";
import "./QuizComponent.css";

function YesNo({
  type,
  num,
  question,
  score,
  data,  // Now correctly receives the options array
  onAnswerChange,
  questionID,
  questionTypeID,
  isCorrect,
  isQuestionsFetched,
  currentPage
}) {
  // Handle answer selection
  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
  };

  // Get icon based on answer correctness
  const getIcon = (option) => {
    // Correct answer selected by user
    if (isCorrect === 1 && option.userAnswer) {
      return <span style={{ color: '#28a745', marginLeft: '5px' }}>✔️</span>; // Green checkmark
    }
    // Incorrect answer, highlight correct answer
    if (isCorrect === 0 && option.correctAnswer) {
      return <span style={{ color: '#28a745', marginLeft: '5px' }}>✔️</span>; // Green checkmark for correct answer
    }
    // Incorrect answer selected by user
    if (isCorrect === 0 && option.userAnswer) {
      return <span style={{ color: '#dc3545', marginLeft: '5px' }}>❌</span>; // Red cross
    }
    return null;
  };

  const isDisabled = type === "review";

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
                <span>
                  <span style={{fontWeight: '650'}}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{fontWeight: '650'}}>
                    {question}
                  </span>
                </span>
              <CForm>
                <CRow>
                  {data.map((option) => (
                    <CCol xs={6} lg={5} key={option.optionId}> {/* Aligning the option */}
                      <div className="d-flex" style={{ marginLeft: "30px" }}>
                        <input
                          // disabled={type === "3" ? false : true}
                          disabled={isDisabled}
                          className="form-check-input options"
                          type="radio"
                          name={`flexRadioDefault-${questionID}`}  // Unique radio group for each question
                          id={option.optionId}
                          value={option.optionValue}
                          onChange={() => handleSelectAnswer(option.optionId)}
                        />
                        <label
                          className="optionText"
                          style={{ marginLeft: "4px" }}
                          htmlFor={option.optionId}
                        >
                          {option.optionValue}
                        </label>
                        {getIcon(option)} {/* Display correct/incorrect icon */}
                      </div>
                    </CCol>
                  ))}
                </CRow>
              </CForm>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default YesNo;
